import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// FAQs published by the owner from searches with no results.
export const useCustomFaqs = (lang, enabled = true) => {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true;
    axios.get(`${API}/faqs`, { params: { lang } })
      .then((r) => { if (alive) setFaqs(Array.isArray(r.data?.faqs) ? r.data.faqs : []); })
      .catch(() => {});
    return () => { alive = false; };
  }, [lang, enabled]);
  return faqs;
};
